import * as d3 from 'd3'
import Chart from '../chart'

import './ConsumptionEvolution.css'

const consumptionEvolutionData = [[{"year":1998,"region":"us","avgConsumption":10950,"relativeEvolutionFrom98":100},{"year":1999,"region":"us","avgConsumption":21950,"relativeEvolutionFrom98":200.45662100456622},{"year":2000,"region":"us","avgConsumption":14400,"relativeEvolutionFrom98":131.50684931506848},{"year":2001,"region":"us","avgConsumption":17200,"relativeEvolutionFrom98":157.07762557077623},{"year":2002,"region":"us","avgConsumption":19500,"relativeEvolutionFrom98":178.08219178082192},{"year":2003,"region":"us","avgConsumption":21800,"relativeEvolutionFrom98":199.08675799086757},{"year":2004,"region":"us","avgConsumption":24600,"relativeEvolutionFrom98":224.65753424657535},{"year":2005,"region":"us","avgConsumption":28400,"relativeEvolutionFrom98":259.3607305936073},{"year":2006,"region":"us","avgConsumption":30550,"relativeEvolutionFrom98":278.99543378995435},{"year":2007,"region":"us","avgConsumption":31250,"relativeEvolutionFrom98":285.38812785388126},{"year":2008,"region":"us","avgConsumption":32050,"relativeEvolutionFrom98":292.69406392694066},{"year":2009,"region":"us","avgConsumption":38350,"relativeEvolutionFrom98":350.22831050228314},{"year":2010,"region":"us","avgConsumption":38000,"relativeEvolutionFrom98":347.0319634703196},{"year":2011,"region":"us","avgConsumption":39150,"relativeEvolutionFrom98":357.5342465753425},{"year":2012,"region":"us","avgConsumption":39450,"relativeEvolutionFrom98":360.2739726027397},{"year":2013,"region":"us","avgConsumption":36000,"relativeEvolutionFrom98":328.7671232876712},{"year":2014,"region":"us","avgConsumption":36500,"relativeEvolutionFrom98":333.33333333333337},{"year":2015,"region":"us","avgConsumption":34350,"relativeEvolutionFrom98":313.6986301369863},{"year":2016,"region":"us","avgConsumption":43900,"relativeEvolutionFrom98":400.91324200913243},{"year":2017,"region":"us","avgConsumption":23450,"relativeEvolutionFrom98":214.1552511415525}],[{"year":1998,"region":"euro","avgConsumption":3550,"relativeEvolutionFrom98":100},{"year":1999,"region":"euro","avgConsumption":4050,"relativeEvolutionFrom98":114.08450704225352},{"year":2000,"region":"euro","avgConsumption":4400,"relativeEvolutionFrom98":123.94366197183098},{"year":2001,"region":"euro","avgConsumption":4750,"relativeEvolutionFrom98":133.80281690140845},{"year":2002,"region":"euro","avgConsumption":5250,"relativeEvolutionFrom98":147.88732394366198},{"year":2003,"region":"euro","avgConsumption":6100,"relativeEvolutionFrom98":171.83098591549296},{"year":2004,"region":"euro","avgConsumption":6900,"relativeEvolutionFrom98":194.3661971830986},{"year":2005,"region":"euro","avgConsumption":8100,"relativeEvolutionFrom98":228.16901408450704},{"year":2006,"region":"euro","avgConsumption":9500,"relativeEvolutionFrom98":267.6056338028169},{"year":2007,"region":"euro","avgConsumption":9900,"relativeEvolutionFrom98":278.8732394366197},{"year":2008,"region":"euro","avgConsumption":11150,"relativeEvolutionFrom98":314.0845070422535},{"year":2009,"region":"euro","avgConsumption":11600,"relativeEvolutionFrom98":326.7605633802817},{"year":2010,"region":"euro","avgConsumption":15500,"relativeEvolutionFrom98":436.6197183098592},{"year":2011,"region":"euro","avgConsumption":11450,"relativeEvolutionFrom98":322.53521126760563},{"year":2012,"region":"euro","avgConsumption":11200,"relativeEvolutionFrom98":315.49295774647885},{"year":2013,"region":"euro","avgConsumption":14350,"relativeEvolutionFrom98":404.2253521126761},{"year":2014,"region":"euro","avgConsumption":13500,"relativeEvolutionFrom98":380.28169014084506},{"year":2015,"region":"euro","avgConsumption":13500,"relativeEvolutionFrom98":380.28169014084506},{"year":2016,"region":"euro","avgConsumption":13650,"relativeEvolutionFrom98":384.50704225352115},{"year":2017,"region":"euro","avgConsumption":12700,"relativeEvolutionFrom98":357.7464788732394}]]
  .map(region => region.map( d => ({ ...d, relativeEvolutionFrom98: d.relativeEvolutionFrom98 - 100 })));

export default class ConsumptionEvolution extends Chart {
  create() {
    this.svg = super.createRoot();

    this.axis = this.svg.append('g')
      .attr('class', 'axis');

    this.xAxis = this.axis.append("g")
      .attr("transform", `translate(0,${this.props.height})`)
      .attr("class", "axis xAxis")

    this.yAxis = this.axis.append("g")
      .attr("class", "axis yAxis")

    this.yAxisLabel = this.axis.append('text')
      .attr("class", "yAxisLabel")
      .attr("text-anchor", "start")
      .attr("x", 3)
      .attr("y", -25);

    this.main = this.svg.append('g')
      .attr('class', 'main');

    this.path = this.main.append("g")
      .attr("class", "evolution")

    this.usPath = this.path.append("path")
      .attr("class", "usEvolution")

    this.euPath = this.path.append("path")
      .attr("class", "euEvolution")
    
    this.pills = this.main.append("g")
      .attr("class", "pills")

    this.appendPillsDrug(this.pills, (-this.props.width * 0.0)-10, this.props.height)
    this.appendPillsDrug(this.pills, (-this.props.width * 0.0)-10, this.props.height / 2)
    this.appendPillsDrug(this.pills, (-this.props.width * 0.02)-10, this.props.height / 2)
    this.appendPillsDrug(this.pills, (-this.props.width * 0.0)-10, 0)
    this.appendPillsDrug(this.pills, (-this.props.width * 0.02)-10, 0)
    this.appendPillsDrug(this.pills, (-this.props.width * 0.04)-10, 0)

    this.legend = this.main.append("g")
      .attr("class", "legend")
    
    this.legendUsa = this.legend.append("g")
      .attr("class", "USA")
      .style("visibility", "hidden")
    this.legendUsa  
      .append("line")
      .attr("x1", this.props.width * 0.75)
      .attr("x2", this.props.width * 0.8)
      .attr("y1", -10)
      .attr("y2", -10)
      .attr("fill", "none")
      .attr("stroke", "grey")
      .attr("stroke-width", 4)
    this.legendUsa
      .append('text')
      .attr("text-anchor", "start")
      .attr("alignment-baseline", "middle")
      .attr("x", this.props.width * 0.81)
      .attr("y", -10)
      .text("USA")
      

    this.legendEurope = this.legend.append("g")
      .attr("class", "Europe")
      .style("visibility", "hidden")
    this.legendEurope
      .append("line")
      .attr("x1", this.props.width * 0.9)
      .attr("x2", this.props.width * 0.95)
      .attr("y1", -10)
      .attr("y2", -10)
      .attr("fill", "none")
      .attr("stroke", "#e91e63")
      .attr("stroke-width", 4)
    this.legendEurope
      .append('text')
      .attr("alignment-baseline", "middle")
      .attr("text-anchor", "start")
      .attr("x", this.props.width * 0.96)
      .attr("y", -10)
      .text("Europe")
  }

  // Main D3 rendering, that should be redone when the data updates.
  update(state) {
    if (JSON.stringify(state) !== JSON.stringify(this.state)) {
      this.drawChart(state);
    }
  }

  appendPillsDrug(selection, x, y) {
    const pillSize = this.props.width * 0.03
    const strokeWidth = Math.round(pillSize*0.08)
    const pill = selection.append("g")
      .attr("class", "pill")
      .attr("transform", `translate(${x},${y}) rotate(90)`)
    pill.append("rect")
      .attr("x", -pillSize/2)
      .attr("y", -pillSize/4)
      .attr("width", pillSize)
      .attr("height", pillSize/2)
      .attr("rx", pillSize/4)
      .attr("ry", pillSize/4)
      .style("fill", "none")
      .style("stroke", "grey")
      .style("stroke-width", strokeWidth)
      .style("stoke-location", "outside")
    pill.append("rect")
      .attr("x", -pillSize/2)
      .attr("y", -pillSize/4)
      .attr("width", pillSize/2)
      .attr("height", pillSize/2)
      .attr("rx", pillSize/4)
      .attr("ry", pillSize/4)
      .style("fill", "grey")
      .style("stroke", "grey")
      .style("stroke-width", strokeWidth)
      .style("stoke-location", "outside")
    pill.append("line")
      .attr("x1", 0)
      .attr("x2", 0)
      .attr("y1", -pillSize/4)
      .attr("y2", pillSize/4)
      .style("fill", "none")
      .style("stroke", "grey")
      .style("stroke-width", strokeWidth*1.2)    
  }

  drawChart(state) {
    const data = {
      usAbsolute: {
        title: 'US',
        color: 'grey',
        values: consumptionEvolutionData[0]
          .map( p => ({x: p.year, y: p.avgConsumption }))
      },
      euAbsolute: {
        title: 'Europe',
        color: '#e91e63',
        values: consumptionEvolutionData[1]
          .map( p => ({x: p.year, y: p.avgConsumption }))
      },
      usRelative : {
        title: 'US',
        color: 'grey',
        values: consumptionEvolutionData[0]
          .map( p => ({x: p.year, y: p.relativeEvolutionFrom98 }))
      },
      euRelative: {
        title: 'Europe',
        color: '#e91e63',
        values: consumptionEvolutionData[1]
          .map( p => ({x: p.year, y: p.relativeEvolutionFrom98 }))
      }
    }

    let extentX, extentY, xAxis;
    if(state.step < 3) {
      const maxY = Math.max(d3.max(data.usAbsolute.values, v => v.y), d3.max(data.euAbsolute.values, v => v.y))
      extentY = [0, maxY];
      extentX = d3.extent(data.usAbsolute.values, v => v.x)
    } else {
      const maxY = Math.max(d3.max(data.usRelative.values, v => v.y), d3.max(data.euRelative.values, v => v.y))
      extentY = [0, maxY];
      extentX = d3.extent(data.usRelative.values, v => v.x) 
    }
    const y = d3.scaleLinear()
      .domain(extentY)
      .range([this.props.height, 0])
      .nice();

    const x = d3.scaleLinear()
      .domain(extentX)
      .range([0, this.props.width])

    xAxis = d3.axisBottom(x)
      .ticks(null, "d")
      .tickSizeOuter(0)

    /*if(state.step < 3) {
      yAxis = d3.axisLeft(y)
        .tickSizeOuter(0)
    } else {
      yAxis = d3.axisLeft(y)
        .tickFormat(d => `+ ${d}%`)
        .tickSizeOuter(0)
    }*/
    
    this.xAxis.call(xAxis);
    /*this.yAxis.call(yAxis);

    this.yAxis.select(".domain")
      .remove();*/
    
    this.yAxis
      .call(d3.axisRight(y)
          .tickSize(this.props.width)
          .ticks(5)
          .tickFormat(d => state.step < 3 ? d : `${d}%`))
      .call(g => g.select(".domain")
          .remove())
      .call(g => g.selectAll(".tick:not(:first-of-type) line")
          .attr("stroke-opacity", 0.3)
          .attr("stroke-dasharray", "2,2"))
      .call(g => g.selectAll(".tick text")
          .attr("x", 4)
          .attr("dy", -4))

    this.yAxisLabel
      .text(state.step < 3 ? "Average opioid consumption (expressed in S-DDD per million inhabitants per day)" : "Relative increase of the opioid consumption since 1998")

    const line = d3.line()
      .curve(d3.curveNatural)
      .x(d => x(d.x))
      .y(d => y(d.y));

    this.usPath
      .attr("fill", "none")
      .attr("stroke", data.usAbsolute.color)
      .attr("stroke-width", 4)
      .style("opacity", 0)

    
    this.legendUsa
      .style("visibility", state.step > 0 ? "visible" : "hidden")
    this.legendEurope
      .style("visibility", state.step > 1 ? "visible" : "hidden")

    if (state.step === 1) {
      this.usPath
        .attr("d", line(state.step < 3 ? data.usAbsolute.values :  data.usRelative.values))
      const totalLength = this.usPath.node().getTotalLength();
      this.usPath
        .attr("stroke-dasharray", totalLength + " " + totalLength)
        .attr("stroke-dashoffset", totalLength)
        .style("opacity", 1)
        .transition()
        .duration(5000)
        .ease(d3.easePoly)
        .attr("stroke-dashoffset", 0);
    } else if(state.step >= 1) {
      this.usPath
        .style("opacity", 1)
        .attr("stroke-dasharray", 0 + " " + 0)
        .attr("stroke-dashoffset", 0)
        .transition()
        .duration((state.step === 3 && state.direction === 'down') || (state.step === 2 && state.direction === 'up') ? 3000 : 0)
        .attr("d", line(state.step < 3 ? data.usAbsolute.values :  data.usRelative.values))
    }

    this.euPath
      .attr("fill", "none")
      .attr("stroke", data.euAbsolute.color)
      .attr("stroke-width", 4)
      .style("opacity", 0)

    if (state.step === 2) {
      this.euPath
        .attr("d", line(state.step < 3 ? data.euAbsolute.values :  data.euRelative.values))
      const totalLength = this.euPath.node().getTotalLength();
      this.euPath
        .attr("stroke-dasharray", totalLength + " " + totalLength)
        .attr("stroke-dashoffset", totalLength)
        .style("opacity", 1)
        .transition()
        .duration(5000)
        .ease(d3.easePoly)
        .attr("stroke-dashoffset", 0);
    } else if(state.step >= 2) {
      this.euPath
        .style("opacity", 1)
        .attr("stroke-dasharray", 0 + " " + 0)
        .attr("stroke-dashoffset", 0)
        .transition()
        .duration((state.step === 3 && state.direction === 'down') || (state.step === 2 && state.direction === 'up') ? 3000 : 0)
        .attr("d", line(state.step < 3 ? data.euAbsolute.values :  data.euRelative.values))
    }
  }
}





// WEBPACK FOOTER //
// ./src/components/charts/ConsumptionEvolution/ConsumptionEvolution.js